module.exports = __webpack_public_path__ + "img/logo-openrice-tc.6d716224.jpg";